<header class="api-error-dialog__header" [ngClass]="'api-error-dialog__header--' + tone">
  <div class="api-error-dialog__icon" aria-hidden="true">
    <i class="bi" [ngClass]="iconClass"></i>
  </div>
  <div class="api-error-dialog__heading">
    <h2 mat-dialog-title class="api-error-dialog__title">{{ data.title }}</h2>
    <span class="api-error-dialog__context">{{ contextLabel }}</span>
  </div>
</header>

<mat-dialog-content class="api-error-dialog__content">
  <p class="api-error-dialog__message">{{ data.message }}</p>

  @if (data.actionText) {
    <section class="api-error-dialog__next-step" aria-labelledby="next-step-title">
      <h3 id="next-step-title">Qué podés hacer</h3>
      <p>{{ data.actionText }}</p>
    </section>
  }

  @if (technicalDetails.length > 0) {
    <details class="api-error-dialog__details">
      <summary>Ver información técnica</summary>
      <div class="api-error-dialog__details-list">
        @for (detail of technicalDetails; track detail) {
          <p>{{ detail }}</p>
        }
      </div>
    </details>
  }
</mat-dialog-content>

<mat-dialog-actions align="end" class="api-error-dialog__actions">
  <button mat-flat-button class="api-error-dialog__close" type="button" (click)="cerrar()">{{ closeText }}</button>
</mat-dialog-actions>
